var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedErrorWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46657 21.0002H19.5266C21.0666 21.0002 22.0266 19.3302 21.2566 18.0002L13.7266 4.99018C12.9566 3.66018 11.0366 3.66018 10.2666 4.99018L2.73657 18.0002C1.96657 19.3302 2.92657 21.0002 4.46657 21.0002ZM11.9966 14.0002C11.4466 14.0002 10.9966 13.5502 10.9966 13.0002V11.0002C10.9966 10.4502 11.4466 10.0002 11.9966 10.0002C12.5466 10.0002 12.9966 10.4502 12.9966 11.0002V13.0002C12.9966 13.5502 12.5466 14.0002 11.9966 14.0002ZM12.9966 18.0002H10.9966V16.0002H12.9966V18.0002Z",
    fill: "#F9C475"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedErrorWarningIcon);
export default __webpack_public_path__ + "static/media/DeprecatedErrorWarningIcon.4004c1c6a77af93b9684421fae6357ba.svg";
export { ForwardRef as ReactComponent };